import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IData, defaultOutreachItem } from "../../../store/outreach/OutreachItem";
import { Card, CardActions, CardContent, CardHeader, Grid, Paper, Typography } from "@material-ui/core";


import { MedewerkersList } from "../../molecules/views/MedewerkersList";
import { OutreachIcon } from "../../atoms/icons/OutreachIcon";
import { Skeleton } from "@material-ui/lab";
import { Contacten } from "../../molecules/views/Contacten";
import { ContactDatum } from "../../molecules/views/ContactDatum";
import { GirStatus, GirStatusOptions } from "../../molecules/views/GirStatus";
import { Aanpasbaar } from "../../molecules/views/Bewerkbaar";
import { Organisatie } from "../../molecules/views/Organisatie";
import { Doelgroepen } from "../../molecules/views/Doelgroepen";
import { Thema } from "../../molecules/views/Thema";
import { Aanwezigen, AanwezigenType } from "../../molecules/views/Aanwezigen";
import { useTranslation } from 'react-i18next';
import { IDetailOrganism } from "../IDetailOrganism";


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDetailOrganism<IData>;
export const OutreachDetail = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tOutreach } = useTranslation('outreach');
    const { t: tDatatypes } = useTranslation('datatypes');
    const data = props.data?.datum ? props.data : defaultOutreachItem;
    return (<Card>
        {props.loading ? <CardHeader title={<Skeleton variant="text" />} subheader={<Skeleton variant="text" />} avatar={<Skeleton variant="circle" />} /> : <CardHeader title={tOutreach('detailTitle', data)} subheader={data.datum.toLocaleDateString()} avatar={<OutreachIcon />} /> }
        <CardContent>
            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">


                <Grid item xs={12} md={6} lg={4}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {tOutreach('detailDopColumn1')}
                    </Typography>

                    <MedewerkersList loading={props.loading} value={data.medewerkers.map(m => ({fullName: m.medewerker, isActive: true}))} size="small" />
                    <Contacten loading={props.loading} label={tDatatypes('contactenLabelPerMedewerker')} value={data.contacts} />
                    <ContactDatum loading={props.loading} value={data.datum} />
                    <GirStatus loading={props.loading} value={data.savedInGir ? GirStatusOptions.Geregistreerd : GirStatusOptions.NogTeRegistreren} />
                    <Aanpasbaar loading={props.loading} value={!data.locked} />
                </Grid>


                <Grid item xs={12} md={6} lg={4}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {tOutreach('detailDopColumn2')}
                    </Typography>
                    
                    <Organisatie loading={props.loading} value={data.organisatie} />
                    <Doelgroepen loading={props.loading} value={data.doelgroepen.map(d => ({id: d.doelgroepId, naam: d.doelgroep}))} detail={data.doelgroepDetail} />
                    <Thema loading={props.loading} value={data.thema} />
                </Grid>


                <Grid item xs={12} md={6} lg={4}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {tOutreach('detailDopColumn3')}
                    </Typography>

                    <Aanwezigen loading={props.loading} value={data.aantalAanwezigProfessioneel} type={AanwezigenType.Professioneel} />
                    <Aanwezigen loading={props.loading} value={data.aantalAanwezigNietProfessioneel} type={AanwezigenType.NietProfessioneel} />
                    <Aanwezigen loading={props.loading} value={data.aantalAanwezigProfessioneel + data.aantalAanwezigNietProfessioneel} type={AanwezigenType.Default} />
                </Grid>


            </Grid>
        </CardContent>
        <CardActions>
            {props.actions}
        </CardActions>
    </Card>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));